import React, { useState, useEffect } from "react";
import "../../../css/CRUDModal.css";
import { apiList } from "../../../helpers/apiList";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import RateCardsPopup from "../RateCardMaster/RateCardsPopup";
import HeaderWithBreadcrumb from "../../../components/common/HeaderWithBreadcrumb";
import MasterTable from "../../../components/common/MasterTable";
import Loader from "../../../components/Loader/Loader";
import AddChargeMasterModal from "./AddChargeMasterModal";
import { formatAmount } from "../../../helpers/helper";
import ChargeMasterFilterModal from "./ChargeMasterFilterModal";
import GetZoneModal from "./GetZoneModal";
import ChargeFilterBar from "./ChargeFilterBar";

const defaultFilterData = {
  source: "",
  express: "",
  rateCardId: "",
  rateCardName:"",
}

const ChargeMaster = () => {
  const [showRateCards, setShowRateCards] = useState(false);
  const [rateCardsVersion, setRateCardsVersion] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const loggedInUserName = sessionStorage.getItem("username");
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [chargeMasterData, setChargeMasterData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageDetails, setPageDetails] = useState(null);
  const [editData, setEditData] = useState({});
  const [modalAction, setModalAction] = useState("");
  const [columnData, setColumnData] = useState("");
  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ✅ Modal open/close
  const openModalCreate = () => setIsModalOpenCreate(true);
  const closeModalCreate = () => setIsModalOpenCreate(false);

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  // ✅ Table headers
  const chargeMasterHeader = [
    "Card Type",
    "Category",
    "Express Type",
    "Weight (kg)",
    "Height (cm)",
    "Length (cm)",
    "Width (cm)",
    "Charges Amt (₹)",
    "Fuel Charges (₹)",
    "GST (%)",
    "Total Charges (₹)",
    "Additional Amt (₹)",
    "Additional Wt (kg)",
    // "Status",
  ];

  const chargeMasterHeaderToKeyMap = {
    "Card Type": "rateCardName",
    "Category": "source",
    "Express Type": "express",
    "Weight (kg)": "weight",
    "Height (cm)": "height",
    "Length (cm)": "length",
    "Width (cm)": "width",
    "Charges Amt (₹)": "amount",
    "Fuel Charges (₹)": "fuelCharges",
    "GST (%)": "gst",
    "Total Charges (₹)": "totalCharges",
    "Additional Amt (₹)": "additionalRate",
    "Additional Wt (kg)": "additionalWeightUnit",
    // Status: "status",
  };

  // ✅ Fetch data (with dummy fallback)
  const fetchChargeMasterData = async (currentPage, filterData) => {
    const payload = {
      username: loggedInUserName,
      ...(filterData?.source && { source: filterData.source }),
      ...(filterData?.express && { express: filterData.express }),
      ...(filterData?.rateCardId && { rateCardId: filterData.rateCardId }),
    };

    setLoading(true);

    try {
      const response = await axiosPostApi(
        `${apiList.FETCH_CHARGES_MASTER}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        payload
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setChargeMasterData(modifiedData);
        setNoData(modifiedData?.length === 0);
      } else {
        // ✅ Use dummy data if API fails
        console.warn("⚠️ Using dummy data - API returned no data");
        setChargeMasterData([]);
        setNoData(true);
      }
    } catch (error) {
      console.warn("⚠️ API failed - showing dummy data for UI testing");
      setChargeMasterData([]);
      setNoData(false);
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const alignRight = (value) => (
      <div
        style={{
          textAlign: "center",
          paddingRight: "12px",
          whiteSpace: "nowrap",
        }}
      >
        {value}
      </div>
    );

    return response?.map((item, index) => ({
      ...item,
      weight: alignRight(formatAmount(item?.weight)),
      height: alignRight(formatAmount(item?.height)),
      length: alignRight(formatAmount(item?.length)),
      width: alignRight(formatAmount(item?.width)),
      amount: (
        <div
          style={{
            textAlign: "right",
            paddingRight: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {formatAmount(item?.amount)}
        </div>
      ),

      fuelCharges: (
        <div
          style={{
            textAlign: "right",
            paddingRight: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {formatAmount(item?.fuelCharges)}
        </div>
      ),

      totalCharges: (
        <div
          style={{
            textAlign: "right",
            paddingRight: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {formatAmount(item?.totalCharges)}
        </div>
      ),

      additionalRate: (
        <div
          style={{
            textAlign: "right",
            paddingRight: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {formatAmount(item?.additionalRate ? item?.additionalRate : 0)}
        </div>
      ),

      additionalWeightUnit: (
        <div
          style={{
            width:"81px",
            textAlign: "end",
            whiteSpace: "nowrap",
          }}
        >
          {formatAmount(item?.additionalWeightUnit ? item?.additionalWeightUnit : 0)}
        </div>
      ),

      weightE: item?.weight,
      heightE: item?.height,
      lengthE: item?.length,
      widthE: item?.width,
      amountE: item?.amount,
      fuelChargesE: item?.fuelCharges,
      totalChargesE: item?.totalCharges,
      additionalRateE: item?.additionalRate,
      additionalWeightUnitE: item?.additionalWeightUnit,
    }));
  };

  useEffect(() => {
    fetchChargeMasterData(1, filterData);
  }, []);

  const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
  };

  // ✅ Modal actions (add, modify, view)
  const handleChargeMaster = (data, actionType = "view") => {
    if (!["add", "modify", "view", "openModal", "delete"].includes(actionType)) return;

    setModalAction(actionType);
    setColumnData(data);

    if (actionType === "add") {
      setEditData({});
      openModalCreate();
    } else if(actionType === "openModal") {
      setIsModalOpen(true);
    }else if(actionType === "delete"){
      let selectedData = chargeMasterData?.find((item) => item?.id === data?.id);
      if (selectedData) {
        setEditData(selectedData);
        openModalCreate();
      }
    }else {
      let selectedData = chargeMasterData.find((item) => item?.id === data?.id);
      if (selectedData) {
        setEditData(selectedData);
        openModalCreate();
      }
    }
  };

  const fetchData = () => fetchChargeMasterData(1, defaultFilterData);
  const totalRecord = pageDetails?.totalRecords || chargeMasterData.length;

  return (
    <>
      <HeaderWithBreadcrumb
        title="Charges Master"
        breadcrumb="Master"
        actions={
          <button
            type="button"
            className="btn btn-sm"
            style={{ border: "1px solid #FF702B", color: "#FF702B", borderRadius: "8px", fontWeight: 500 }}
            onClick={() => setShowRateCards(true)}
          >
            Rate Cards
          </button>
        }
      />
      {showRateCards && (
        <RateCardsPopup
          onClose={() => {
            setShowRateCards(false);
            setRateCardsVersion((v) => v + 1);
            fetchChargeMasterData(currentPage || 1, filterData); // card names may have changed
          }}
        />
      )}
      <ChargeFilterBar
        filters={filterData}
        refreshKey={rateCardsVersion}
        onChange={(next) => {
          setFilterData(next);
          setCurrentPage(1);
          fetchChargeMasterData(1, next);
        }}
      />
      <div>
        <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px] py-[10px]">
          {loading ? (
            <div className="flex justify-center items-center py-10">
              <Loader />
            </div>
          ) : (
            <MasterTable
              loading={loading}
              headers={chargeMasterHeader}
              data={chargeMasterData}
              filterFields={[]}
              entityType="ChargeMaster"
              headerToKeyMap={chargeMasterHeaderToKeyMap}
              handleAction={handleChargeMaster}
              noData={noData}
              pageDetails={pageDetails}
              currentPage={currentPage}
              pageSize={pageSize}
              totalRecord={totalRecord}
              fetchNextData={(page) => fetchChargeMasterData(page, filterData)}
              setCurrentPage={setCurrentPage}
              openModalFilter={openModalFilter}
              handleReset={handleReset}
              filterData={filterData}
              setPageSize={setPageSize}
              fetchData={fetchData}
              hideFilterControls
            />
          )}

          {isModalOpenCreate && (
            <AddChargeMasterModal
              show={isModalOpenCreate}
              handleClose={closeModalCreate}
              editData={editData}
              action={modalAction}
              callApi={() => fetchChargeMasterData(1, filterData)}
              columnData={columnData}
              setCurrentPage={setCurrentPage}
            />
          )}

          {isModalOpenFilter ? (
            <ChargeMasterFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setSmsData={setChargeMasterData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
              setCurrentPage={setCurrentPage}
            />
          ) : null}

          {isModalOpen && (
            <GetZoneModal
              show={isModalOpen}
              handleClose={() => setIsModalOpen(false)}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ChargeMaster;
